import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SettingSlice {
  edittingInterface: ("lan" | "wan" | "lte" | "alarm" | "period" | "wifi")[];
}

export const initialState: SettingSlice = {
  edittingInterface: [],
};

const settingSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setEdittingInterface: (state, action: PayloadAction<SettingSlice["edittingInterface"]>) => {
      state.edittingInterface = action.payload;
    },
  },
});

export const { setEdittingInterface } = settingSlice.actions;

export default settingSlice;
